module.exports = __webpack_public_path__ + "163ae70ae31a1886e830cb551d5db28d.fbx";